/* src/app/modules/taxes/quarterly-tax-receipt/quarterly-tax-receipt-edit/quarterly-tax-receipt-edit.component.css */
:host {
  --qtr-brand: #e3fd64;
  --qtr-brand-d: #4d7a00;
  --qtr-brand-bg: rgba(227, 253, 100, 0.08);
  --qtr-text: #1a1d23;
  --qtr-muted: #6b7280;
  --qtr-border: #e5e7eb;
  --qtr-surface: #ffffff;
  --qtr-radius: 10px;
  --qtr-shadow: 0 2px 8px rgba(0,0,0,0.07);
  display: block;
}
.qtr-edit-page {
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.qtr-edit-header {
  display: flex;
  align-items: center;
  gap: 12px;
}
.qtr-edit-header__title {
  margin: 0;
  font-size: 19px;
  font-weight: 700;
  color: var(--qtr-text);
}
.qtr-edit-header__sub {
  margin: 3px 0 0;
  font-size: 12.5px;
  color: var(--qtr-muted);
}
.qtr-card {
  background: var(--qtr-surface);
  border: 1px solid var(--qtr-border);
  border-radius: var(--qtr-radius);
  box-shadow: var(--qtr-shadow);
  overflow: hidden;
}
.qtr-card__head {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  background: var(--qtr-brand);
}
.qtr-card__head mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  color: var(--qtr-brand-d);
}
.qtr-card__head-label {
  font-size: 13px;
  font-weight: 600;
  color: var(--qtr-brand-d);
}
.qtr-card__body {
  padding: 20px;
}
.qtr-edit-layout {
  display: flex;
  gap: 24px;
  align-items: flex-start;
}
.qtr-edit-layout__form {
  flex: 0 0 320px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.qtr-edit-layout__doc {
  flex: 1;
  min-width: 0;
}
.qtr-fields {
  display: flex;
  flex-direction: column;
}
.qtr-save-bar {
  display: flex;
  gap: 10px;
  padding-top: 8px;
}
.qtr-btn-save {
  background-color: var(--qtr-brand) !important;
  color: rgba(0, 0, 0, .85) !important;
  font-weight: 600 !important;
  border-radius: 8px !important;
}
.qtr-doc-wrap {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.qtr-pdf-preview {
  height: 70vh;
  border: 1px solid var(--qtr-border);
  border-radius: var(--qtr-radius);
  overflow: hidden;
}
.qtr-img-preview {
  max-width: 100%;
  border-radius: var(--qtr-radius);
  border: 1px solid var(--qtr-border);
}
@media (max-width: 768px) {
  .qtr-edit-layout {
    flex-direction: column;
  }
  .qtr-edit-layout__form {
    flex: none;
    width: 100%;
  }
}
/*# sourceMappingURL=quarterly-tax-receipt-edit.component.css.map */
